<template>
  <div
    class="flex flex-col overflow-hidden border-solid rounded-lg bg-whiteOverride border-1 border-border"
    :class="{ 'opacity-25': disabled }"
  >
    <div class="w-full min-h-ml bg-offWhite px-lg">
      <slot name="header"></slot>
    </div>
    <slot />
  </div>
</template>

<script>
export default {
  name: 'HeaderBox',
  props: {
    disabled: Boolean,
  },
};
</script>
